import { render, staticRenderFns } from "./FormDataTable.vue?vue&type=template&id=22a3db9c&scoped=true"
import script from "./FormDataTable.vue?vue&type=script&lang=js"
export * from "./FormDataTable.vue?vue&type=script&lang=js"
import style0 from "./FormDataTable.vue?vue&type=style&index=0&id=22a3db9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3db9c",
  null
  
)

export default component.exports